/**
 * Insurance damage types (Maintenance.DAMAGE_TYPE_CHOICES), in the same order. The list is
 * CABAS Finland's Vahinkolaji list, which the insurers' e-invoice codes follow too.
 * Labels: t(`damageType.${value}`).
 */
export const DAMAGE_TYPES = [
  'collision',
  'traffic',
  'glass',
  'vandalism',
  'elk',
  'reindeer',
  'animal',
  'parking',
  'nature',
  'theft',
  'burglary',
  'fire',
  'liability',
  'transport',
  'breakage',
  'other',
];
